// CTSK-268 slice B — the tab-header edit lock. Default LOCKED: the
// registry table stays display-only (pre-268 behavior) and the edit
// affordance is hidden. Unlocking is a deliberate operator signal —
// it reveals the edit affordance next to this toggle (the caller owns
// what "unlocked" exposes; TimelineLane shows the per-tab "Edit YAML"
// button). Stateless like RegistryTableHeader: the caller owns the
// locked flag so it can re-lock on tab switches.

import { Lock, Unlock } from 'lucide-react';

export interface EditLockToggleProps {
  locked: boolean;
  onToggle: () => void;
}

export function EditLockToggle({ locked, onToggle }: EditLockToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={!locked}
      aria-label={locked ? 'Unlock editing' : 'Lock editing'}
      title={
        locked
          ? 'Unlock editing for this tab (reveals the edit affordance)'
          : 'Lock editing for this tab (back to display-only)'
      }
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '4px 10px',
        fontSize: 12,
        border: '1px solid var(--border-strong)',
        borderRadius: 6,
        background: locked ? 'var(--surface-raised)' : 'color-mix(in srgb, var(--warning-primary, #A05A00) 12%, var(--surface-raised))',
        color: locked ? 'var(--text-secondary)' : 'var(--warning-primary, #A05A00)',
        cursor: 'pointer',
      }}
    >
      {locked ? <Lock size={12} aria-hidden /> : <Unlock size={12} aria-hidden />}
      {locked ? 'Locked' : 'Unlocked'}
    </button>
  );
}
